// extracted by mini-css-extract-plugin
export default {"image-preview":"ProductDetails_image-preview__OBJb5","row":"ProductDetails_row__Em0mk"};